import { render, staticRenderFns } from "./lazy-background.vue?vue&type=template&id=23a76d14&"
import script from "./lazy-background.vue?vue&type=script&lang=js&"
export * from "./lazy-background.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports